import { BoxProps, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { useState } from 'react'
import { Switch } from 'react-native'
import { ExpandAddView } from '../../components/ExpandAddView'
import { useStores } from '../../data/store'
import { ApprovalTypes } from '../../utils/constants'
import { MasterApprovals } from '../EntityApprovals/MasterApprovals'
import { EssAuditTrials } from '../EssAuditTrials'

const SystemControlConfigApprovals = () => {
  const { hasAuditAccess, isAccessConfigPriviledged } = useStores((store) => ({
    hasAuditAccess: store.user.getAccessConfig(['sys_control_config', 'audit', 'approval_audit_fetch', 'isAccessible']),
    isAccessConfigPriviledged: store.user.getAccessConfig([
      'sys_control_config',
      'audit',
      'approval_audit_privileged',
      'isAccessible',
    ]),
  }))

  const [isUserApprover, setUserApprover] = useState(false)

  const handleToggle = (val: boolean) => {
    setUserApprover(val)
  }

  return (
    <ModBox>
      <ModBox {...styles.container}>
        <ExpandAddView title={'Banking Code Approvals'}>
          <MasterApprovals type={ApprovalTypes.BANKING_CODE} />
        </ExpandAddView>
        <Spacer size={16} direction="vertical" />
        <ModBox {...styles.container} show={hasAuditAccess}>
          <ModBox show={!isAccessConfigPriviledged} p={40} align={'center'} justify={'flex-end'} flexDirection={'row'}>
            <TextNew title={'User'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
            <SpacerNew direction={'horizontal'} size={12} />
            <Switch onValueChange={handleToggle} value={isUserApprover} />
            <SpacerNew direction={'horizontal'} size={12} />
            <TextNew title={'Approver'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
          </ModBox>
          <Spacer direction="vertical" size={24} />
          <ExpandAddView title={'Banking Code Approvals - Audit Trail'}>
            <EssAuditTrials type={ApprovalTypes.BANKING_CODE_AUD_TRIAL} isApprover={isUserApprover} />
          </ExpandAddView>
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  container: {
    ...shadow,
  } as BoxProps,
}

export default SystemControlConfigApprovals
